import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AcademyService } from 'src/app/manage/academies/service/academies.service';
import { AcademypaymentService } from 'src/app/services/academyPayment';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-academy-payment-page',
  templateUrl: './academy-payment-page.component.html',
  styleUrls: ['./academy-payment-page.component.scss'],
  providers: [MessageService],
})
export class AcademyPaymentPageComponent implements OnInit {
  availableClasses: string[] = ["dark", "Payment", "colorful"];
  currentClassIdx: number = 0;
  bodyClass: string;
  public selectedMembershipType;
  public membershipTypeList = environment.membershipTypeList;
  public showError;
  public academyId;
  private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
  private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
  private endUserId;
  private userEmail;
  public academyDetails: any[] = [];
  public tokenData;
  public token;
  public academyPaymentDetails;
  public showLinkExpireMsg =false;
  constructor(
    private winRef: WindowRefService,
    private activeroute: ActivatedRoute,
    private router: Router,
    private academyService: AcademyService,
    private academyPaymentService: AcademypaymentService,
    private tokenStorageService: TokenStorageService,
    private messageService: MessageService
  ) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  ngOnInit(): void {
    this.activeroute.queryParams.subscribe(params => {
      this.endUserId = params.id;
    });
    this.token = this.activeroute.snapshot.params.token;
    
    this.getAcademyDetailsByUserId();
  }
  getAcademyDetailsByUserId() {
    let query = "?filterByDisable=false&filterByUserId=" + this.endUserId;
    this.academyService.getAcademyList(query).subscribe(
      data => {
        this.academyDetails = data.data.items[0];
        this.academyId = this.academyDetails['id'];
        this.getAcademypaymentdetails();
      },
      err => {

      }
    );
  }
  
  getAcademypaymentdetails(){
    let query = "?filterByStatus=pre_order&filterByAcademyId=" + this.academyId;
    console.log(query);
    this.academyPaymentService.getAcademyPaymentListwithoutAuth(query).subscribe(
      data => {
        if(data.data.items.length > 0){
            if(data.data.totalCount > 0){
              this.showLinkExpireMsg = true;
            } else {
              this.showLinkExpireMsg = false;
            }
        } else {
          this.showLinkExpireMsg = false;
        }        
      },
      err => {

      }
    );
  }
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;
    if (bodyElement) {
      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];
      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);
      this.bodyClass = nextClass;
    }
  }
  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }
  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  onClickPlan(membership) {
    this.selectedMembershipType = membership.value;
    this.showError = false;
    this.membershipTypeList.forEach(element => {
      if (element.value == this.selectedMembershipType) {
        let index = this.findIndexByValue(this.selectedMembershipType, this.membershipTypeList);
        if (index != -1) {
          this.membershipTypeList[index]['selected'] = true;
        }
      } else {
        element['selected'] = false;
      }
    })
  }
  findIndexByValue(value, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].value === value) {
        index = i;
        break;
      }
    }
    return index;
  }

  onClickPayNow() {
    let index = this.findIndexByValue(this.selectedMembershipType, this.membershipTypeList);
    this.showError = false;
    let membershipData;
    if (index != -1) {
      membershipData = this.membershipTypeList[index];
    } else {
      this.showError = true;
      return;
    }
    if (membershipData != undefined) {
      let dataObj = {};
      dataObj['academyId'] = this.academyId;
      dataObj['amount'] = membershipData.amount;
      dataObj['duration'] = membershipData.duration;
      dataObj['membershipType'] = this.selectedMembershipType;
      dataObj['endUserId'] = this.endUserId;
      dataObj['status'] = "pre_order";
      dataObj['token'] = this.token;
      this.academyPaymentService.addAcademyPayment(dataObj).subscribe(
        data => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: membershipData.amount * 100,
            currency: 'INR',
            name: 'TPL',
            description: 'Academic Registration Payment',
            image: '../../../../assets/images/logo.png',
            order_id: data.data.orderId,
            modal: {
              escape: false,
              "ondismiss": function () {
                window.location.reload();
              }
            },
            notes: {
            },
            theme: {
              color: '#0c238a'
            },

          };
          options.handler = ((response, error) => {
            options.response = response;
            let verifyPaymentData = { 'razorpay_payment_id': response.razorpay_payment_id, 'razorpay_order_id': response.razorpay_order_id, 'razorpay_signature': response.razorpay_signature, 'renewalstatus':"pre_order"};

            this.academyPaymentService.verfiyAcademypayment(verifyPaymentData).subscribe(async paymentdata => {
              //this.loadAcademyPayments(this.tableLazyLoadEvent);
              let endUserId = await this.encryptUsingAES256(this.endUserId);
              let paymentStatus = await this.encryptUsingAES256('successful');
              let paymentMode = await this.encryptUsingAES256('renewal');
              let updatedData = {
                payment_status: paymentStatus,
                endUserId: endUserId,
                orderId: data.data.orderId,
                payment_mode: paymentMode
              }
              this.academyService.updateAcademyStatus(this.academyId, updatedData).subscribe(
                data => {
                  // this.tokenStorageService.isLoggedOut();
                  // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                  // this.router.onSameUrlNavigation = 'reload';
                  // this.router.navigateByUrl("/sign-in");
                  this.router.navigate(['/thank-you']);
                  //this.showThankyouModal = true;
                },
                err => {
                });
            })
          })
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open()
        },
        (err) => {
          this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.error, life: 6000 });
        }
      );
    }
  }

  async encryptUsingAES256(text): Promise<any> {
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }
}
